import { Editor, Node, Range } from 'slate';
import { ReactEditor } from 'slate-react';
import getTextFromNode from 'components/text-editor/hooks/use-custom-editor/actions/get-text-from-node';
import isNodeTextEqualToWindowSelection from 'components/text-editor/hooks/use-custom-editor/actions/is-node-text-equal-to-window-selection';
import { textIncludesWindowSelection } from 'utils/js';

export type GetFocusedNode = (selection?: Range) => Node | null;

export default function getFocusedNode(editor: ReactEditor): GetFocusedNode {
  return function (selection?: Range): Node | null {
    const at = (selection || editor.selection) as Range;

    // For some reason Editor.nodes returns only paragraph type by default. So we first search for custom type and if there
    // is no match we do another search for paragraphs

    function findNodeInSelection(selection, options?) {
      return Array.from(Editor.nodes(editor, { at, ...options })).map(
        ([node]) => node,
      );
    }

    function includesTextSelection(node) {
      return textIncludesWindowSelection(getTextFromNode(node as Node));
    }

    if (at) {
      const match = (node) => {
        return true;
      };

      if (window.getSelection()?.toString()) {
        const result = findNodeInSelection(selection, { match, mode: 'all' });

        return (
          result?.find(isNodeTextEqualToWindowSelection(editor)) ||
          result?.find(includesTextSelection) ||
          (null as any)
        );
      }

      let [node = null] =
        findNodeInSelection(selection, { mode: 'lowest', match }) || [];

      if (!node) {
        [node = null] =
          findNodeInSelection(selection, { mode: 'all', match }) || [];
      }

      if (!node) {
        [node = null] =
          findNodeInSelection(selection, { mode: 'lowest' }) || [];
      }

      return node;
    }

    return null;
  };
  /*return function (selection?: Range): Node | null {
    const at = (selection || editor.selection) as Range;

    // For some reason Editor.nodes returns only paragraph type by default. So we first search for custom type and if there
    // is no match we do another search for paragraphs

    function findNodeInSelection(selection, options?) {
      return Array.from(Editor.nodes(editor, { at, ...options })).map(
        ([node]) => node,
      );
    }

    function includesTextSelection(node) {
      return textIncludesWindowSelection(getTextFromNode(node as Node));
    }

    if (at) {
      const match = (node) => node.type === 'custom';

      if (window.getSelection()?.toString()) {
        const result = findNodeInSelection(selection, { match, mode: 'all' });

        return (
          result?.find(isNodeTextEqualToWindowSelection(editor)) ||
          result?.find(includesTextSelection) ||
          (null as any)
        );
      }

      let [node = null] =
        findNodeInSelection(selection, { mode: 'lowest', match }) || [];

      if (!node) {
        [node = null] =
          findNodeInSelection(selection, { mode: 'all', match }) || [];
      }

      if (!node) {
        [node = null] =
          findNodeInSelection(selection, { mode: 'lowest' }) || [];
      }

      return node;
    }

    return null;
  };*/
}
